export default "__VITE_ASSET__c763f074__"